import { apiGetUsers, fetchAssigneeUsers } from '@jove-frontend/uikit';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { IUsersStore } from './types';

export const useUsersStore = create<IUsersStore>()(
  immer((set, get) => ({
    state: {
      users: null,
      isLoading: false,
      joveAssigneeUsers: [],
    },
    actions: {
      initialize: async () => {
        set((store) => {
          store.state.isLoading = true;
        });
        const { fetchUsers } = get().actions;

        await fetchUsers();

        set((store) => {
          store.state.isLoading = false;
        });
      },
      fetchUsers: async () => {
        const [res, err] = await apiGetUsers({});

        if (res) {
          set((store) => {
            store.state.users = res.data;
          });
        }

        return res;
      },
      getUserById: (id: string) => {
        const { users } = get().state;

        return users?.find((user) => user.user.id === id);
      },
      fetchJoveAssigneeUsers: async () => {
        let list = await fetchAssigneeUsers({ organizationSlug: 'joveco' });

        list = list.filter((item) => !!item.value);
        if (list) {
          set((store) => {
            store.state.joveAssigneeUsers = list;
          });
        }

        return list;
      },
    },
  }))
);
